import React from "react";

function Privacy(props) {
  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-0 bg-white pt-20">
      <h1 className="text-4xl lg:text-5xl">Hallimo Privacy Policy</h1>

      <p className="text-sm lg:text-base text-[#374D5D]">
        Hallimo ("Hallimo," "we," "us," or "our") respects the privacy of our
        users ("you" or "your"). This Privacy Policy explains how we collect,
        use, and disclose your information when you use the Hallimo platform
        (the "Platform").
      </p>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        1. Information We Collect
      </h1>
      <p className="text-sm lg:text-base text-[#374D5D] pb-3">
        We collect several types of information when you use the Platform:
      </p>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              <b>Registration Information:</b> When you register for an account,
              we collect your email address and the username you choose.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              <b>Payment Information:</b> For any payments, including potential
              subscriptions, we collect your payment details through secure
              third-party processors. Note, we do not store your full credit
              card information.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              <b>Usage Data:</b> We collect data about your activity on the
              Platform, such as the features you access, the content you view,
              and the duration of your sessions.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              <b>Device Information:</b> We collect information about the device
              you use to access the Platform, such as your IP address, device
              type, operating system, and browser type.
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        2. How We Use Your Information
      </h1>
      <p className="text-sm lg:text-base text-[#374D5D] pb-3">
        We use your information for the following purposes:
      </p>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              To provide and operate the Platform and its features.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              To process payments and manage subscriptions (if applicable).
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              To send you relevant information about the Platform, such as
              updates, promotions, and new features.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              To personalize your experience based on your activity and
              preferences.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              To analyze usage patterns and improve the Platform.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              To comply with legal obligations, enforce our agreements, and
              resolve disputes.
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        3. Sharing Your Information
      </h1>
      <p className="text-sm lg:text-base text-[#374D5D]">
        We may share your information with third-party service providers who
        assist us in operating the Platform, such as payment processors and data
        analytics providers. These third parties are obligated to protect your
        privacy and use your information only to perform the services we
        request.
      </p>
      <p className="text-sm lg:text-base text-[#374D5D]">
        We may also disclose your information if required by law or if we
        believe such disclosure is necessary to comply with a legal obligation,
        such as a court order, subpoena, or other legal processes, or to protect
        the rights, property, or safety of Hallimo, our users, or the public.
      </p>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">4. Data Retention</h1>
      <p className="text-sm lg:text-base text-[#374D5D]">
        We retain your information for as long as your account is active or as
        needed to provide you with the services you requested. Additionally, we
        retain your information to comply with our legal obligations, resolve
        disputes, and enforce our agreements.
      </p>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">5. Your Choices</h1>
      <p className="text-sm lg:text-base text-[#374D5D] pb-3">
        You have the following rights regarding your information:
      </p>
      <div className="md:px-5">
        <ul>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              <b>Access and Update:</b> You can access and update your account
              information at any time.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              <b>Unsubscribe:</b> You can unsubscribe from marketing
              communications by following the unsubscribe instructions in our
              emails.
            </p>
          </li>
          <li>
            <p className="text-sm lg:text-base text-[#374D5D]">
              <b>Deletion:</b> You can delete your personal information directly
              through your account profile settings. Alternatively, if you
              prefer, you can request deletion by contacting us at{" "}
              <b>info@hallimo.com.</b>
            </p>
          </li>
        </ul>
      </div>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">6. Security</h1>
      <p className="text-sm lg:text-base text-[#374D5D]">
        We take reasonable measures to protect your information from
        unauthorized access, disclosure, alteration, or destruction. However,
        please note that no method of electronic transmission or storage is 100%
        secure, and we cannot guarantee absolute security.
      </p>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        7. International Transfers
      </h1>
      <p className="text-sm lg:text-base text-[#374D5D]">
        Your information may be transferred to, and processed in, countries
        other than your own. These countries may have different data protection
        laws than those in your country.
      </p>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        8. Changes to this Privacy Policy
      </h1>
      <p className="text-sm lg:text-base text-[#374D5D]">
        We may update this Privacy Policy from time to time. Any changes will be
        posted on the Platform, and the date of the latest revision will be
        indicated at the top of the policy. We encourage you to review this
        Privacy Policy periodically for any updates.
      </p>

      <h1 className="text-3xl lg:text-4xl mb-2 mt-10">
        9. Contact Information
      </h1>
      <p className="text-sm lg:text-base text-[#374D5D]">
        If you have any questions or concerns about this Privacy Policy, please
        contact us at:
      </p>
      <p className="text-sm lg:text-base text-[#374D5D]">
        <b>Email: info@hallimo.com</b>
      </p>
    </div>
  );
}

export default Privacy;
